export default {
  verificationPayment: {
    companyConfirmed: "This company has already been verified",
    verification: "Verification by bank transfer",
    confirm: "Do you want to confirm company authorization?",
    modal1: {
      title: "Choose a verification method",
      internetTransfer: "Online bank transfer",
      p24: "Fast online transfer via Przelewy24",
      traditionalTransfer: "Traditional transfer",
      traditionalInfo: "Verification within 24 hours after funds are credited",
      sum: "The transfer should be made for the amount of 1.00 PLN to the following details.",
      return: "Funds will be refunded within 14 business days after verification.",
    },
    transferInfo: {
      name: "Recipient name",
      nameValue: "ANOTHER INVEST sp. z o.o.",
      address: "Recipient address",
      addressValue: "ul. Mikołaja Kopernika 5/LU9 00-367 Warszawa",
      account: "Account number",
      accountValue: "28 1090 2590 0000 0001 4866 7707",
      title: "Transfer title",
      amount: "Amount",
      titleValue: "Company account verification ID",
      download: "Download form",
    },
  },
};
